import { Chip } from "@mui/material";
import { AccountBalanceWalletOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import type { SxProps, Theme } from "@mui/material/styles";
import { useTranslation } from "shared/hooks/useTranslation";
import { useUserSession } from "shared/contexts/UserContext";


export interface WalletEmptyHintProps {
    sx?: SxProps<Theme>;
}

/**
 * Inline hint when the user has no wallets (or none matching the filter).
 * Links to the Accounts page.
 */
export default function WalletEmptyHint({ sx }: WalletEmptyHintProps) {
    const { t, getPathWithLanguage } = useTranslation();
    const navigate = useNavigate();
    const { profile } = useUserSession();
    return (
        <Chip
            icon={<AccountBalanceWalletOutlined />}
            label={t("wallet.noWalletsHint")}
            size="small"
            variant="outlined"
            clickable
            onClick={() => navigate(getPathWithLanguage(`/${profile?.username ?? ""}/accounts`))}
            sx={{
                fontWeight: 500,
                ...((sx ?? {}) as object),
            }}
        />
    );
}
